import React from 'react';
import PropTypes from 'prop-types';
import ButtonLink from '../../../common/components/ButtonLink';
import Redirect from '../../../common/components/Redirect';
import {
  TitleBar,
  DocTitle,
} from '../../../common/components/Layout/StandardPageTemplate/Context';
import withQuery from '../../../common/components/withQuery';
import PasswordForm from '../../../common/components/PasswordForm';
import Template from '../components/Template';
import styles from './ResetPW.css';

class ResetPW extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
    }),
  };
  static contextTypes = {
    activateServiceDialog: PropTypes.func,
  };
  state = {
    resetSuccess: false,
  };

  handleSuccess = () => {
    return this.setState(prevState => ({
      ...prevState,
      resetSuccess: true,
    }));
  };

  handleFailure = ({ resp }) => {
    if (resp && resp.status === 500) {
      return this.context.activateServiceDialog();
    }
  };

  render() {
    // return to login if we don't have a reset key
    const { query } = this.props.location || {};
    if (!query || !query.resetkey) {
      return <Redirect to="/auth/login" />;
    }

    const { resetSuccess } = this.state;
    const title = resetSuccess
      ? 'Successfully updated password.'
      : 'Enter a new password below.';

    const pageTitle = 'Reset Password';

    return (
      <div>
        <TitleBar title={pageTitle} />
        <DocTitle title={`${pageTitle} | Engage | NFIB`} />
        <Template title={title}>
          {!resetSuccess ? (
            <PasswordForm
              passwordEndpoint={`/api/cuss/credentials/${query.resetkey}/resetpassword`}
              onSuccess={this.handleSuccess}
              onFailure={this.handleFailure}
            />
          ) : null}
        </Template>
        {resetSuccess ? (
          <ButtonLink
            to="/auth/login"
            label="login"
            raised
            primary
            className={styles.loginButton}
          />
        ) : null}
      </div>
    );
  }
}

export default withQuery(ResetPW);



// WEBPACK FOOTER //
// ./src/App/auth/Views/ResetPW.js